import React, { useEffect, useState } from 'react';
import styles from './MonoConnect.module.scss'
import Connect from '@mono.co/connect.js'; // Adjust the path accordingly
import Tab from '../tab-viewer/Tab';
import { toast } from 'react-toastify';
import CommonCheckBox from '../checkbox/CommonCheckBox';

type Props = {
  customerDetails: {
    firstName: string
    lastName: string,
    email: string,
    bvn: string
  }
  isBvnVerified: boolean
  isMonoVerified: boolean
  checked?: boolean
  onChecked?: (value: boolean) => void
  onRetrievedMonoToken: (monoTemporaryToken: string) => void
}

const MonoConnect: React.FC<Props> = (props: Props) => {

  const [ isSuccess, setIsSuccess ] = useState(props.isMonoVerified ?? false);
  const [ isTermsAccepted, setIsTermsAccepted ] = useState<boolean>(props.checked ?? false)

  const onMonoButtonClick = () => {
    if (!isTermsAccepted) {
			toast.warning("You have to accept the terms");
			return;
		}
    monoConnect.open();
  }

  const monoConnect = React.useMemo(() => {

    const onSuccessMethod = (data: any) => {
      props.onRetrievedMonoToken(data.code);
    }

    const customer = {
      name: `${props.customerDetails.firstName} ${props.customerDetails.lastName}`,
      email: props.customerDetails.email,
      identity: {
        type: 'bvn',
        number: props.customerDetails.bvn
      },
    }

    const monoInstance = new Connect({
      onClose: () => console.log('Widget closed'),
      onLoad: () => console.log('Widget loaded successfully'),
      onSuccess: (data) => onSuccessMethod(data),
      key: process.env.REACT_APP_MONO_SDK_CONNECT_PUBLIC_KEY!,
      data: { customer }
    })

    monoInstance.setup()
    
    return monoInstance;
  }, [props])

  useEffect(() => {
    setIsSuccess(props.isMonoVerified)
  }, [props.isMonoVerified])

  const onToggleCheckBox = () => {
    setIsTermsAccepted(!isTermsAccepted)
    if (props.onChecked != null) {
      props.onChecked(!isTermsAccepted)
    }
  }

  return (
    <div className={styles.monoSection}>
      <div className={styles.monoDescription}>
      To confirm your transaction history using credit bureau, we require your bank statement for the last of  6 to 12 months.
      <br/>
      <span className={styles.boldPart}> We advise you to link your salary account as this boosts your credit score and approval chances.</span>
      </div>
      
      <div className={styles.agreement}>
        <CommonCheckBox className={styles.authPaymentCheckBox} isVisible selected={isTermsAccepted} onToggle={onToggleCheckBox} />
        <span>I agree that Yansa Analytics can access my Financial Information and process it to determine my credit worthiness</span>
      </div>

      <button id="launch-btn" disabled={!props.isBvnVerified || props.isMonoVerified} className={`${styles.monoBtn} standardButton ${!props.isBvnVerified && styles.disableButton}`} onClick={onMonoButtonClick}>
        {
          isSuccess 
          ?
            (
            <div className={styles.monoBtnContent}>
              <Tab isFinished={true} isCurrent={false} label={''} onClick={() => null} />
              Successfully Connected to Mono
            </div>
            )
          : 
            (
              <div className={styles.monoBtnContent}>
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <rect width="30" height="30" fill="url(#pattern0_1288_4663)"/>
                    <defs>
                        <pattern id="pattern0_1288_4663" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlinkHref="#image0_1288_4663" transform="scale(0.005)"/>
                        </pattern>
                        <image id="image0_1288_4663" width="200" height="200" xlinkHref="data:image/jpeg;base64,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"/>
                    </defs>
                </svg>
                Get account Statement with Mono
              </div>
            )
        }
      
      </button>

      {/* <div className={styles.monoUploadPdf}>
          Do you have your bank statement in PDF?
          <span className={styles.uploadHere} onClick={() => null}> Upload here</span>
      </div> */}
    </div>
  );
};

export default MonoConnect;
